import { render, staticRenderFns } from "./SubscriptionConfigurationAdd.vue?vue&type=template&id=0be68a5d&scoped=true"
import script from "./SubscriptionConfigurationAdd.vue?vue&type=script&lang=js"
export * from "./SubscriptionConfigurationAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be68a5d",
  null
  
)

export default component.exports